export default __webpack_public_path__ + "static/media/energybar@2x.57ca5b8f.jpg";